module.exports = __webpack_public_path__ + "static/media/share.70ee7ce4.png";